/* eslint react/prop-types: 0 */

import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import { getQRCodeClientInfo, postQrCodeLogin } from '@actions/qrcode';
import { setRuntimeVariable } from '@actions/runtime';

import PopUp from './popup';
// eslint-disable-next-line css-modules/no-unused-class
import s from './popup.css';

class PopUpContainer extends Component {
  state = {
    openPopup: this.props.runtime.qrCodeQid ? true : false
  };

  handleClose = () => {
    this.setState({
      openPopup: false
    });
    document.body.style.overflow = '';
  };

  handlePostQRCode = () => {
    const qid = this.props.runtime.qrCodeQid;
    if (qid) {
      this.props.postQrCodeLogin(qid);
      document.body.style.overflow = '';
    }
  };

  componentDidMount() {
    const qid = this.props.runtime.qrCodeQid;
    if (qid) {
      this.props.getQRCodeClientInfo(qid);
      document.body.style.overflow = 'hidden';
    }
  }

  componentDidUpdate() {
    const { meta: { postStatus } } = this.props.qrcode;
    if (this.props.runtime.qrCodeQid !== '' && postStatus === 'success') {
      this.props.setRuntimeVariable({ name: 'qrCodeQid', value: '' });
      document.body.style.overflow = '';
    }
  }

  render() {
    const { openPopup } = this.state;
    const {
      meta: { status: qrcodeClientStatus, postStatus },
      data: qrcodeClientData
    } = this.props.qrcode;
    const loginStatus =
      this.props.user.sid && this.props.user.token ? true : false;
    const isValid =
      qrcodeClientStatus === 'success' &&
      qrcodeClientData.client_name !== '' &&
      postStatus !== 'success'
        ? true
        : false;

    return (
      <>
        {openPopup &&
          isValid && (
          <PopUp
            handlePostQRCode={this.handlePostQRCode}
            handleClose={this.handleClose}
            clientName={qrcodeClientData.client_name}
            loginStatus={loginStatus}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = state => {
  return { ...state };
};

const mapDispatchToProps = dispatch => ({
  getQRCodeClientInfo: qid => dispatch(getQRCodeClientInfo(qid)),
  postQrCodeLogin: qid => dispatch(postQrCodeLogin(qid)),
  setRuntimeVariable: objRuntime => dispatch(setRuntimeVariable(objRuntime))
});

export default compose(
  withStyles(s),
  connect(mapStateToProps, mapDispatchToProps)
)(PopUpContainer);
